import { AUTH_USER_LOGIN, AuthTypes, AUTH_USER_LOGOUT, AUTH_USER_SIGNUP, AUTH_USER_FIRSTSIGNUP, AUTH_USER_SECONDSIGNUP, AUTH_USER_THIRDSIGNUP, AUTH_USER_FOURTHSIGNUP, CHANGE_FIRST_TIME } from '../actions/actionTypes'
import { States } from 'safe'

const initialState: States.Auth = {
  user: null,
  userRegisterProcess: null
}

//eslint-disable-next-line
export default (state: States.Auth = initialState, action: AuthTypes) => {
  switch (action.type) {
    case AUTH_USER_LOGIN:
      return { ...state, ...action.payload }
    case AUTH_USER_LOGOUT:
      return { user: null }
    case AUTH_USER_FIRSTSIGNUP:
      return {...state, userRegisterProcess: { ...state.userRegisterProcess, ...action.payload } }
    case AUTH_USER_SECONDSIGNUP:
      return {...state, userRegisterProcess: { ...state.userRegisterProcess, ...action.payload } }
    case AUTH_USER_THIRDSIGNUP:
      return {...state, userRegisterProcess: {...state.userRegisterProcess, ...action.payload}}
      case AUTH_USER_SIGNUP:
      return {...state, ...action.payload}
    case AUTH_USER_FOURTHSIGNUP:
      return {...state, userRegisterProcess: {...state.userRegisterProcess, ...action.payload}}
    // case CHANGE_FIRST_TIME:
    //   return {...state, ...action.payload }
    default:
      return state
  }
}
